// global
import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
// api
import { listHealthProfessionAssociation } from 'app/api/healthProfessionAssociation';
// views
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';

function HealthProfessionAssociationDropdown(props) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    listHealthProfessionAssociation()
      .then(response => {
        const healthProfessionAssociations = [];
        response.forEach(res =>
          healthProfessionAssociations.push({
            text: `${res.initials} - ${res.name}`,
            value: res.id
          })
        );
        setOptions(healthProfessionAssociations);
      })
      .catch(setOptions([]));
  }, []);

  const {
    width,
    value,
    onChange,
    required,
    showLabel = true,
    isForm = true,
    error,
    styleName,
    placeholder = 'Selecionar associação',
    label = 'Associação',
    ...rest
  } = props;

  return (
    <CustomDropdown
      placeholder={placeholder}
      label={showLabel && <ErrorLabel label={label} error={error} />}
      selection
      required={required}
      isForm={isForm}
      width={width}
      options={options}
      value={value}
      onChange={onChange}
      searchable={true}
      error={error}
      styleName={styleName}
      {...rest}
    />
  );
}

HealthProfessionAssociationDropdown.propTypes = {
  width: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
  showLabel: PropTypes.bool,
  isForm: PropTypes.bool,
  error: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  styleName: PropTypes.string
};

export default memo(HealthProfessionAssociationDropdown);
